import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer, X } from "lucide-react";

const formatMXN = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n || 0);

export default function Ticket({ open, onOpenChange, sale }) {
  if (!sale) return null;
  const created = new Date(sale.created_at);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm bg-white border-warm-border p-0 overflow-hidden" data-testid="ticket-dialog">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="font-outfit">Ticket de venta</DialogTitle>
          <DialogDescription>Folio {sale.folio} · {created.toLocaleString("es-MX")}</DialogDescription>
        </DialogHeader>

        <div id="print-ticket" className="px-6 pb-2 font-mono text-[12px] leading-relaxed text-stone">
          <div className="text-center mb-3">
            <div className="font-outfit font-bold text-lg">LOSERÍA</div>
            <div className="text-stone/60">Tienda de pisos y azulejos</div>
            <div className="text-stone/60">Tel: 555-000-0000</div>
          </div>
          <div className="border-t border-dashed border-stone/30 my-2" />
          <div className="flex justify-between">
            <span>Folio:</span>
            <span className="font-bold">{sale.folio}</span>
          </div>
          <div className="flex justify-between">
            <span>Fecha:</span>
            <span>{created.toLocaleString("es-MX")}</span>
          </div>
          <div className="flex justify-between">
            <span>Cajero:</span>
            <span>{sale.cashier_name}</span>
          </div>
          <div className="border-t border-dashed border-stone/30 my-2" />
          <div className="grid grid-cols-12 gap-1 text-[11px] font-bold uppercase">
            <div className="col-span-7">Producto</div>
            <div className="col-span-2 text-right">Cant</div>
            <div className="col-span-3 text-right">Imp.</div>
          </div>
          <div className="border-t border-dashed border-stone/30 my-1" />
          {sale.items.map((it, i) => (
            <div key={i} className="grid grid-cols-12 gap-1 mb-1">
              <div className="col-span-12 text-[11px]">{it.name}</div>
              <div className="col-span-7 text-stone/60">{formatMXN(it.price)}</div>
              <div className="col-span-2 text-right">{it.quantity}</div>
              <div className="col-span-3 text-right">{formatMXN(it.price * it.quantity)}</div>
            </div>
          ))}
          <div className="border-t border-dashed border-stone/30 my-2" />
          <div className="flex justify-between">
            <span>Subtotal:</span>
            <span>{formatMXN(sale.subtotal)}</span>
          </div>
          {sale.discount > 0 && (
            <div className="flex justify-between">
              <span>Descuento:</span>
              <span>-{formatMXN(sale.discount)}</span>
            </div>
          )}
          <div className="flex justify-between font-bold text-base mt-1">
            <span>TOTAL:</span>
            <span>{formatMXN(sale.total)}</span>
          </div>
          <div className="border-t border-dashed border-stone/30 my-2" />
          <div className="flex justify-between">
            <span>Pago:</span>
            <span className="uppercase">{sale.payment_method}</span>
          </div>
          {sale.cash_received > 0 && (
            <>
              <div className="flex justify-between">
                <span>Recibido:</span>
                <span>{formatMXN(sale.cash_received)}</span>
              </div>
              <div className="flex justify-between">
                <span>Cambio:</span>
                <span>{formatMXN(sale.change)}</span>
              </div>
            </>
          )}
          <div className="text-center mt-3 text-stone/60">
            ¡Gracias por su compra!
          </div>
        </div>

        <DialogFooter className="px-6 py-4 bg-sand border-t border-warm-border gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            data-testid="ticket-close"
            className="border-warm-border"
          >
            <X className="w-4 h-4 mr-2" /> Cerrar
          </Button>
          <Button
            onClick={handlePrint}
            data-testid="ticket-print"
            className="bg-clay hover:bg-clay-hover text-white"
          >
            <Printer className="w-4 h-4 mr-2" /> Imprimir
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
